module.exports = __webpack_public_path__ + "img/Print.9564a1e8.svg";